import React from "react";
import TextTheme from "components/General/Text/TextTheme";
import "components/Tribe/Friends/FriendsHome/FriendListContainer.css";
import * as CONSTANT from "constants/text";
import { ButtonBase } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import "components/Tribe/Friends/UserDetail/FriendUserProfileBox.css"
import Popover from 'react-bootstrap/Popover'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import CustomRadioPopup from "components/General/Form/Popup/CustomRadioPopup";
import CustomDecisionPopup from "components/General/Form/Popup/CustomDecisionPopup";
/* Use hooks to store state in the function. */
import { useState } from 'react';
/*Group helper methods*/
import * as Groups from "components/Tribe/Groups/GroupHelperMethods.js"

function MemberSettings(props) {

    // hook for the member settings popup
    const [rolePopupOpen, setRoleOpen] = useState(false);
    const [removePopupOpen, setRemoveOpen] = useState(false);


    /**
    * Function to change role of group member
    */
    function onMemberRoleChange(role) {
        Groups.changeRole(props.groupId, props.name, role);
        setRoleOpen(false);
    }

    return (
        <div>
            <OverlayTrigger
                trigger={'click'}
                placement="top"
                rootClose={true}
                overlay={
                    <Popover>
                        <Popover.Title as="h3"><center>{props.name}'s settings</center></Popover.Title>
                        <Popover.Content>
                            <center>
                                <Button
                                    size="small"
                                    variant="outlined"
                                    component="span"
                                    style={{
                                        textTransform: "None", margin: "0px", border: "0px solid",
                                    }}
                                    onClick={() => (setRoleOpen(true))}
                                >
                                    <TextTheme
                                        message={CONSTANT.CHANGE_ROLE}
                                        className={"text_xsmall text_bold text_dark_bright_blue"}
                                    />
                                </Button>
                                <br />
                                <Button
                                    size="small"
                                    variant="outlined"
                                    component="span"
                                    style={{
                                        textTransform: "None", margin: "0px", border: "0px solid",
                                    }}
                                    onClick={() => (setRemoveOpen(true))}
                                >
                                    <TextTheme
                                        message={CONSTANT.REMOVE_FROM_GROUP}
                                        className={"text_xsmall text_bold text_dark_bright_blue"}
                                    />
                                </Button>
                            </center>
                        </Popover.Content>
                    </Popover>
                }>
                <ButtonBase
                    style={{ borderRadius: "10px", }}
                >
                    <div
                        className="settings_icon"
                        style={{ width: "30px", height: "30px" }}
                    ></div>
                </ButtonBase>
            </OverlayTrigger>
            {rolePopupOpen ?
                (
                    <CustomRadioPopup
                        isOpen={true}
                        popupTitle={"Change " + props.name + "'s group role"}
                        popupDescription={
                            props.name +
                            CONSTANT.CHANGE_ROLE_DESCRIPTION +
                            props.role
                        }
                        radioTitle={CONSTANT.SELECT_NEW_ROLE}
                        radioValue1={getNewRole(0, props.role)}
                        radioValue2={getNewRole(1, props.role)}
                        acceptButtonText={CONSTANT.SAVE}
                        declineButtonText={CONSTANT.DECLINE_BLOCK}
                        acceptButtonClick={onMemberRoleChange}
                        declineButtonClick={() => (setRoleOpen(false))}
                    />
                ) : null
            }
            {removePopupOpen ?
                (
                    <CustomDecisionPopup
                        isOpen={true}
                        popupTitle={CONSTANT.REMOVE + props.name + " from your group?"}
                        popupDescription={
                            CONSTANT.REMOVE_FROM_GROUP_WARNING1 +
                            props.name +
                            CONSTANT.REMOVE_FROM_GROUP_WARNING2
                        }
                        acceptButtonText={CONSTANT.ACCEPT_REMOVE+props.name}
                        declineButtonText={CONSTANT.DECLINE_CANCEL}
                        acceptButtonClick={() => Groups.deleteMembership(props.groupId, props.name, CONSTANT.REMOVE_FROM_GROUP)}
                        declineButtonClick={()=>(setRemoveOpen(false))}
                    />
                ) : null
            }
        </div>
    );
}


/*Function to return a value pointed at by index of a role that the user is not */
function getNewRole(index, role) {
    //array of roles
    let roles = [CONSTANT.OWNER, CONSTANT.MODERATOR, CONSTANT.MEMBER];
    let newRoles = [];
    // loop through array and get the roles that are new
    for (var i in roles) {
        if (roles[i] !== role) {
            newRoles.push(roles[i]);
        }
    }
    return newRoles[index]
}

export default MemberSettings;
